const KILLSWITCH_NAMES = {
  // example for local killswitch:
  // navTestKs: 'navTestKs',
  showMinimalSearch: 'showMinimalSearch',
  registryDropdownEnabled: 'registryDropdownEnabled',
  hmacKey: 'hmacKey',
  xMacysApiKey: 'xMacysApiKey',
  persistentLoginEnabled: 'persistentLoginEnabled',
  enhancedDesktopNavEnabled: 'enhancedDesktopNavEnabled',
  useCommonSearchPageUrlPattern: 'useCommonSearchPageUrlPattern',
  vueDealsEnabled: 'vueDealsEnabled',
  internationalContextEnabled: 'internationalContextEnabled',
  isNewBestSellerSubdomain: 'isNewBestSellerSubdomain',
  priceSimplificationEnabled: 'priceSimplificationEnabled',
  convoCommerceEnabled: 'convoCommerceEnabled',
  newGoogleAPICallEnabled: 'newGoogleAPICallEnabled',
  newPlacesDetailsApiEnabled: 'newPlacesDetailsApiEnabled',
  storeInPreferenceDatabaseEnabled: 'storeInPreferenceDatabaseEnabled',
  aiQuickShopEnabled: 'aiQuickShopEnabled',
  cardActivationEnhancementsEnabled: 'cardActivationEnhancementsEnabled',
  cardActivationEnhancementsFooterEnabled: 'cardActivationEnhancementsFooterEnabled',
  cardActivationEnhancementsAccountFlyoutEnabled: 'cardActivationEnhancementsAccountFlyoutEnabled',
  creditNewAccountDiscountEnabled: 'creditNewAccountDiscountEnabled',
  masterAiFloatingActionButtonEnabled: 'masterAiFloatingActionButtonEnabled',
  aiFloatingActionButtonEnabled: 'aiFloatingActionButtonEnabled',
  masterPopularSearchesEnabled: 'masterPopularSearchesEnabled',
  masterMewWhitespaceRemovalEnabled: 'masterMewWhitespaceRemovalEnabled',
  mewWhitespaceRemovalEnabled: 'mewWhitespaceRemovalEnabled',
  masterGraySearchBarProminenceEnabled: 'masterGraySearchBarProminenceEnabled',
  graySearchBarProminenceEnabled: 'graySearchBarProminenceEnabled',
  masterAskMacysPromptsEnabled: 'masterAskMacysPromptsEnabled',
  masterDisableMediaRail: 'masterDisableMediaRail',
  disableMediaRail: 'disableMediaRail',
  masterNewSearchModalEnabled: 'masterNewSearchModalEnabled',
  newSearchModalEnabled: 'newSearchModalEnabled',
  masterScrollyCatsEnabled: 'masterScrollyCatsEnabled',
  scrollyCatsEnabled: 'scrollyCatsEnabled',
  popularSearchesArm1: 'popularSearchesArm1',
  popularSearchesArm2: 'popularSearchesArm2',
  askMacysPromptsArmOne: 'askMacysPromptsArmOne',
  askMacysPromptsArmTwo: 'askMacysPromptsArmTwo',
  masterBestSellerExperimentEnabled: 'masterBestSellerExperimentEnabled',
  topPanelEnabled: 'topPanelEnabled',
  bestSellerPanelEnabled: 'bestSellerPanelEnabled',
};

const localKillswitches = {
  // Example:
  // [KILLSWITCH_NAMES.navTestKs]: true,
};

const ALLOWED_KILLSWITCHES = {
  // example for local killswitch:
  // [KILLSWITCH_NAMES.navTestKs]: true,
  [KILLSWITCH_NAMES.showMinimalSearch]: true,
  [KILLSWITCH_NAMES.registryDropdownEnabled]: true,
  [KILLSWITCH_NAMES.hmacKey]: true,
  [KILLSWITCH_NAMES.xMacysApiKey]: true,
  [KILLSWITCH_NAMES.persistentLoginEnabled]: true,
  [KILLSWITCH_NAMES.enhancedDesktopNavEnabled]: true,
  [KILLSWITCH_NAMES.useCommonSearchPageUrlPattern]: true,
  [KILLSWITCH_NAMES.vueDealsEnabled]: true,
  [KILLSWITCH_NAMES.internationalContextEnabled]: true,
  [KILLSWITCH_NAMES.isNewBestSellerSubdomain]: true,
  [KILLSWITCH_NAMES.priceSimplificationEnabled]: true,
  [KILLSWITCH_NAMES.convoCommerceEnabled]: true,
  [KILLSWITCH_NAMES.newGoogleAPICallEnabled]: true,
  [KILLSWITCH_NAMES.newPlacesDetailsApiEnabled]: true,
  [KILLSWITCH_NAMES.storeInPreferenceDatabaseEnabled]: true,
  [KILLSWITCH_NAMES.aiQuickShopEnabled]: true,
  [KILLSWITCH_NAMES.cardActivationEnhancementsEnabled]: true,
  [KILLSWITCH_NAMES.cardActivationEnhancementsFooterEnabled]: true,
  [KILLSWITCH_NAMES.cardActivationEnhancementsAccountFlyoutEnabled]: true,
  [KILLSWITCH_NAMES.creditNewAccountDiscountEnabled]: true,
  [KILLSWITCH_NAMES.masterAiFloatingActionButtonEnabled]: true,
  [KILLSWITCH_NAMES.aiFloatingActionButtonEnabled]: true,
  [KILLSWITCH_NAMES.masterPopularSearchesEnabled]: true,
  [KILLSWITCH_NAMES.masterMewWhitespaceRemovalEnabled]: true,
  [KILLSWITCH_NAMES.mewWhitespaceRemovalEnabled]: true,
  [KILLSWITCH_NAMES.masterGraySearchBarProminenceEnabled]: true,
  [KILLSWITCH_NAMES.graySearchBarProminenceEnabled]: true,
  [KILLSWITCH_NAMES.masterAskMacysPromptsEnabled]: true,
  [KILLSWITCH_NAMES.masterDisableMediaRail]: true,
  [KILLSWITCH_NAMES.disableMediaRail]: true,
  [KILLSWITCH_NAMES.masterNewSearchModalEnabled]: true,
  [KILLSWITCH_NAMES.newSearchModalEnabled]: true,
  [KILLSWITCH_NAMES.masterScrollyCatsEnabled]: true,
  [KILLSWITCH_NAMES.scrollyCatsEnabled]: true,
  [KILLSWITCH_NAMES.popularSearchesArm1]: true,
  [KILLSWITCH_NAMES.popularSearchesArm2]: true,
  [KILLSWITCH_NAMES.askMacysPromptsArmOne]: true,
  [KILLSWITCH_NAMES.askMacysPromptsArmTwo]: true,
  [KILLSWITCH_NAMES.masterBestSellerExperimentEnabled]: true,
  [KILLSWITCH_NAMES.topPanelEnabled]: true,
  [KILLSWITCH_NAMES.bestSellerPanelEnabled]: true,
};

// we should not expose these killswtitches in SSR response due to security
const CLIENT_SIDE_ONLY_KILLSWITCHES = {
  [KILLSWITCH_NAMES.hmacKey]: true,
  [KILLSWITCH_NAMES.xMacysApiKey]: true,
};

export { localKillswitches, ALLOWED_KILLSWITCHES, CLIENT_SIDE_ONLY_KILLSWITCHES, KILLSWITCH_NAMES };
